/**
 * Landeseite des Abmeldelinks aus den Mails zum Guthaben (#155).
 *
 * Abgemeldet hat schon billing/abmelden, bevor es hierher weiterleitet: die
 * Function liefert kein HTML aus (Supabase macht daraus Text). Diese Seite
 * sagt nur, was passiert ist. Ohne Anmeldung erreichbar, der Link kommt aus
 * dem Postfach.
 */

import { Hinweis, Rahmen } from '../ui';
import { t } from '../sprache';

const SUPPORT_ADRESSE = 'run@99takes.com';

export default function Abgemeldet() {
  const fehler = new URLSearchParams(window.location.search).has('fehler');
  if (fehler) {
    return (
      <Rahmen titel={t('Das hat nicht geklappt', 'That did not work')} unter={t('Der Abmeldelink war unvollständig, oder wir konnten ihn gerade nicht verarbeiten.', 'The unsubscribe link was incomplete, or we could not process it right now.')}>
        <Hinweis art="schlecht">
          {t(
            <>Schreib kurz an <a href={`mailto:${SUPPORT_ADRESSE}`} className="text-marke-tief underline">{SUPPORT_ADRESSE}</a>, dann tragen wir dich von Hand aus.</>,
            <>Write a short note to <a href={`mailto:${SUPPORT_ADRESSE}`} className="text-marke-tief underline">{SUPPORT_ADRESSE}</a> and we will remove you by hand.</>,
          )}
        </Hinweis>
      </Rahmen>
    );
  }
  return (
    <Rahmen titel={t('Du bist abgemeldet', 'You are unsubscribed')} unter={t('Mails zu deinem Guthaben bekommst du nicht mehr.', 'You will no longer get emails about your balance.')}>
      <p className="m-0 text-[0.9375rem] leading-relaxed text-text-leise">
        {t(
          <>Mails, die zu deinem Konto gehören, etwa ein neues Passwort, kommen weiter an. Wie viele Credits du noch hast,
        siehst du jederzeit in deinem Konto.</>,
          <>Emails that belong to your account, such as a new password, still arrive. You can see how many credits you have left
        in your account at any time.</>,
        )}
      </p>
    </Rahmen>
  );
}
